import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as styles from './Table.module.scss';

const ThemeContext = createContext('lightGrey');

const Table = ({ children, theme = 'lightGrey' }) => (
  <ThemeContext.Provider value={theme}>
    <div className={classNames(styles.container, styles[theme])}>
      <table className={styles.table}>{children}</table>
    </div>
  </ThemeContext.Provider>
);

Table.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['lightGrey', 'neutralNavy'])
};

export const TableRow = ({ children }) => <tr className={styles.row}>{children}</tr>;

TableRow.propTypes = {
  children: PropTypes.node.isRequired
};

export const TableHeading = ({ children }) => (
  <thead className={styles.head}>
    <TableRow>{children}</TableRow>
  </thead>
);

TableHeading.propTypes = {
  children: PropTypes.node.isRequired
};

export const TableBody = ({ children }) => <tbody className={styles.body}>{children}</tbody>;

TableBody.propTypes = {
  children: PropTypes.node.isRequired
};

export const TableCell = ({ children, fill, textSize, strong, as: As = 'td' }) => {
  const theme = useContext(ThemeContext);

  return (
    <As
      className={classNames(styles.cell, {
        [styles[theme]]: theme,
        [styles.fill]: fill,
        [styles[textSize]]: textSize,
        [styles.strong]: strong
      })}
    >
      <div>{children}</div>
    </As>
  );
};

TableCell.propTypes = {
  children: PropTypes.node,
  fill: PropTypes.bool,
  as: PropTypes.oneOf(['td', 'th']),
  textSize: PropTypes.oneOf(['md', 'lg']),
  strong: PropTypes.bool
};

export default Table;
